import useSWR from 'swr';

import { SWR_GLOBAL_CONFIG } from '~/api/_constant';
import { request } from '~/api/_utils/request';
import { PostT } from '~/state/post';

const getPath = () => `/v1/challenges/intilaq_posts`;

export async function apiGetV1IntilaqChallengePosts() {
  const response = await request.GET<{ posts: PostT[] }>(getPath());
  return response.posts;
}

export function useSWRV1IntilaqChallengePosts() {
  const swr = useSWR(getPath(), () => apiGetV1IntilaqChallengePosts(), SWR_GLOBAL_CONFIG);
  return { ...swr, posts: swr.data };
}
